<script lang="ts">
	interface Props {
		enable?: boolean
		flex?: boolean
		children?: import('svelte').Snippet
		message?: import('svelte').Snippet
	}

	let { enable = false, flex = false, children, message }: Props = $props()
</script>

<div
	class="{flex ? 'flex flex-col' : 'grid grid-cols-1'} {enable
		? 'contents'
		: 'pointer-events-none opacity-50 grayscale'}"
>
	{@render children?.()}
</div>

{#if !enable}
	{@render message?.()}
{/if}
